<template>
  <validation-observer
    ref="observerSettings"
    v-slot="{ invalid }"
    slim>
    <oie-edit-wrapper :title="t('notificationsHeader')" class="my-notifications" :contained="true">
      <template v-if="notifications" #preview-content>
        <div class="my-notifications__preview">
          <p><span>{{ tStatic('email') }}: </span><span> {{ notifications.deliveryNotificationEmail }}</span></p>
          <p><span>{{ tStatic('phoneLabel') }}: </span><span>{{ notifications.deliveryNotificationPhone }}</span></p>
          <p><span>{{ t('newsletterLabel') }}: </span><span>{{ notifications.newsletter ? tStatic('genericYes') : tStatic('genericNo') }}</span></p>
        </div>
      </template>
      <template #edit-actions="{ toggle }">
        <oie-action-wrapper>
          <oie-base-action theme="skeleton" size="large" @click="exit(toggle)">
            {{ tStatic('genericClose') }}
          </oie-base-action>
          <oie-base-action
            size="large"
            :disabled="invalid"
            @click="save(toggle)">
            {{ tStatic('genericSave') }}
          </oie-base-action>
        </oie-action-wrapper>
      </template>
      <template v-if="notifications" #edit-content>
        <div class="input-column__container">
          <validation-provider v-slot="{ errors }" rules="email" slim>
            <oie-base-input-v2
              v-model="notifications.deliveryNotificationEmail"
              :label="tStatic('email')"
              :placeholder="tStatic('emailPlaceholder')"
              :errors="errors"></oie-base-input-v2>
          </validation-provider>

          <validation-provider v-slot="{errors}" rules="mobile:^[0-9+]+$" slim>
            <oie-phone-input
              v-if="activeCountry"
              v-model="notifications.deliveryNotificationPhone"
              :country-code="activeCountry.callingCode"
              :errors="errors"></oie-phone-input>
          </validation-provider>

          <oie-base-radio-checkbox
            v-model="notifications.newsletter"
            :label="t('newsletterLabel')"
            class="input-column__checkbox"></oie-base-radio-checkbox>
        </div>
      </template>
    </oie-edit-wrapper>
  </validation-observer>
</template>

<script>
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  data() {
    return {
      notifications: null,
      pristineNotifications: null
    }
  },
  computed: {
    activeCountry() {
      return this.clientModel.countryList.find(c => c.value === this.notifications.invoiceAddress.countryCode)
    }
  },
  async mounted() {
    const response = await httpService.get('auth/mynotifications')
    this.notifications = _.merge({}, response.data)
    this.pristineNotifications = _.merge({}, response.data)
  },
  methods: {
    async save(toggle) {
      await httpService.post('auth/mynotifications',
        { email: this.notifications.deliveryNotificationEmail,
          phone: this.notifications.deliveryNotificationPhone,
          newsletter: this.notifications.newsletter
        })

      this.pristineNotifications = _.merge({}, this.notifications)

      toggle()
    },
    exit(toggle) {
      this.notifications = _.merge({}, this.pristineNotifications)
      toggle()
    }
  }
}
</script>

<style lang="scss">
.my-notifications__preview p{
  @include body-smaller;
  margin: 0;
}
</style>
